'use client'
import { Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { HeadContainer } from '.'

const CAUTION_DATA: string[] = [
  '1) Read and understand “Use Caution” thoroughly before dyeing your hair.',
  '2) Perform a Patch Test 48 hours before use.',
  '3) The dye might stain your fingernails if left unwashed for a long time; clean your hands first while you leave shampoo on your hair.',
  '4) Tools that touch your hair, such as glasses, contact lenses, accessories, hair, etc. may get discoloured. Do not wear them while you are dyeing your hair.',
  '5) Rinse thoroughly; otherwise, it may cause skin trouble, etc.',
  '6) Avoid direct sunlight and keep it in a cool place.',
  '7) For any remaining product, close the lid before storing.'
]

const Caution = () => {
  return (
    <HeadContainer
      mx={'auto'}
      position={'absolute'}
      top={'-350px'}
      mt={'350px'}
      zIndex={2}
    >
      <VStack data-aos="fade-up" alignItems={'center'} my={10} gap={5}>
        <VStack borderBottom={'3px solid #686868'} w="100%">
          <Text textStyle={'qaTitle'} textAlign="center">
            Ellixi Black Change Shampoo
          </Text>
          <Text textStyle={'qaTitleMax'} color={'red'}>
            Caution
          </Text>
        </VStack>
        <VStack
          alignItems={'start'}
          gap={5}
          width="100%"
          px={{
            md: 8,
            base: 2
          }}
        >
          {CAUTION_DATA.map((caution, i) => {
            return (
              <Text data-aos="fade-up" key={i} textStyle={'qaAnswer'}>
                {caution}
              </Text>
            )
          })}
        </VStack>
      </VStack>
    </HeadContainer>
  )
}

export default Caution
